module.exports = __webpack_public_path__ + "img/skull_2.ba77b238.png";